export class ExternalSegmentsFetchFailed extends Error {
    constructor() {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExternalSegmentsFetchFailed);
        }
        this.name = "ExternalSegmentsFetchFailed";
        this.message = "Failed to fetch external segments. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map